import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventario-popular',
  templateUrl: './lista.component.html'
})

export class PopularComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

}